const ElSalvadorSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111362)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0003 0C12.0711 0 5.21986 4.61445 1.98486 11.3044H38.0157C34.7808 4.61445 27.9295 0 20.0003 0Z"
        fill="#0052B4"
      />
      <path
        d="M20.0003 39.9997C27.9295 39.9997 34.7808 35.3852 38.0158 28.6953H1.98486C5.21986 35.3852 12.0711 39.9997 20.0003 39.9997Z"
        fill="#0052B4"
      />
      <path d="M15.9839 20.8696L20.0003 13.9131L24.0167 20.8696H15.9839Z" fill="#FFDA44" />
      <path
        d="M25.2176 23.1657L20.0001 25.7745L14.7827 23.1657V19.6875H25.2176V23.1657Z"
        fill="#6DA544"
      />
      <path
        d="M24.9193 14.2119L23.0747 16.0565C23.8615 16.8433 24.3482 17.9303 24.3482 19.1309C24.3482 21.5321 22.4016 23.4787 20.0004 23.4787C17.5993 23.4787 15.6526 21.5321 15.6526 19.1309C15.6526 17.9303 16.1393 16.8433 16.9261 16.0565L15.0815 14.2119C13.8225 15.4707 13.0439 17.2098 13.0439 19.1309C13.0439 22.9729 16.1585 26.0874 20.0004 26.0874C23.8424 26.0874 26.9569 22.9729 26.9569 19.1309C26.9568 17.2098 26.1782 15.4707 24.9193 14.2119Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111362">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ElSalvadorSvg;
